import { render, staticRenderFns } from "./fundraiser_form.vue?vue&type=template&id=8a65ed76&"
import script from "./fundraiser_form.vue?vue&type=script&lang=js&"
export * from "./fundraiser_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports